import React, { useState } from "react";
import SelectInput from "../../components/SelectInput";
import {
  Button,
  Chip,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Table from "../../components/Table/Table";
import { useNavigate, useParams } from "react-router-dom";
import useInventory from "./hook/useInventory";
import { FaRegEdit } from "react-icons/fa";
import TextInput from "../../components/TextField";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Pagination } from "../../components/pagination/Pagination";
import { ToastContainer } from "react-toastify";
import Modal from "../../components/Modal";
import { da } from "date-fns/locale";
import TextFields from "../../components/TextField";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MultipleSelect from "../../components/MultipleSelect";

const Inventory = () => {
  const navigate = useNavigate();
  const { data, methods } = useInventory();

  const {
    inventoryData,
    error,
    inventoryDetails,
    statusType,
    totalCount,
    controller,
    isLoading,
    inventoryList,
    stockData,
    inventoryPermission,
    stockModal,
    stockId,
    assignType,
    purchaseModal,
    vendorList,
    formDataCreatePurchase,
    formDataVendor,
    vendorModal,
    assignModal,
    formDataAssignStock,
    employeeList,
    formErrorCreatePurchase,
    formErrorAssignStock,
    errorVendor
  } = data;
  const {
    handleInputChange,
    applayFilter,
    resetFilter,
    setStatusType,
    handlePagination,
    setStockModal,
    setStockId,
    setQuantity,
    AddUpdateStock,
    handleInputStockChange,
    setStockData,
    handleOpenPurchaseModal,
    handleClosePurchaseModal,
    addPurchaseStock,
    handleChangeCreatePirce,
    handleChangeVendor,
    handleOpenVendorModal,
    handleCloseVendorModal,
    addVendor,
    handleOpenAssignModal,
    handleCloseAssignModal,
    handleChangeAssignStock,
    addAssignStock,
    addUseStock,
    setFormErrorCreatePurchase,
    setFormDataCreatePurchase,
    setFormDataAssignStock,
    setFormErrorAssignStock,
  } = methods;
  const { add, edit, view } =
    inventoryPermission?.userInfo?.permission?.inventory;

  const TableHead = [
    { label: "#", id: "" },
    { label: "Product Name", id: "name" },
    { label: "Category", id: "category" },
    { label: "Vendor", id: "vendor" },
    { label: "Stock Quantity", id: "stockQuantity" },
    { label: "Available Quantity", id: "availableQuantity" },
    // { label: "MRP", id: "mrp" },
    // { label: "Purchase Price", id: "purchasePrice" },
    { label: "Re-order", id: "reorder" },
    { label: "Used Quantity", id: "quantityUsed" },
    { label: "Action", id: "action" },
  ];

  const typeOfAssignList = [
    { name: "Permanent", id: "Permanent" },
    { name: "Temporary", id: "Temporary" },
  ];

  // const openModal = () => {
  //   handleClosePurchaseModal(); // Close purchase first
  //   handleOpenVendorModal(); // Then open vendor modal
  // };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="row align-items-center mb-3 g-2">
          {/* <div className="d-flex justify-content-between align-items-center"> */}
          <div className="col-12 col-md-8 d-flex flex-wrap gap-2">
            {/* <InputLabel id="custom-select-label" sx={{ fontSize: "13px" }}>Search</InputLabel> */}

            <TextField
              size="small"
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
              sx={{ width: "210px" }}
              name="search"
              value={statusType?.search}
              onChange={(e) =>
                setStatusType((pre) => ({ ...pre, search: e.target.value }))
              }
            />
            <Button
              className="me-2"
              variant="contained"
              size="small"
              onClick={applayFilter}
              startIcon={<SearchIcon />}
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={resetFilter}
              startIcon={<RestartAltIcon />}
            >
              Reset
            </Button>
          </div>
        </div>
        <div className="row ">
          <div className="col-12 ticket">
            <div className="bg shadow radius">
              <div className="">
                <div className="mt-2">
                  <table className="table">
                    <Table
                      TableHeadData={TableHead}
                      rowCount={TableHead?.length}
                    />
                    <tbody>
                      {inventoryList?.data.map((item, index) => {
                        return (
                          <tr
                            className="text-start rounded-row "
                            style={{
                              borderRadius: "50px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <td className="table-link">
                              {controller.rowsPerPage * (controller.page - 1) +
                                index +
                                1}{" "}
                            </td>
                            <td
                              className="table-link"
                              onClick={() =>
                                navigate(
                                  `/inventory/${item._id}/purchase-order`,
                                  { state: { item } }
                                )
                              }
                            >
                              {item?.productName}
                            </td>
                            <td className="">{item?.category?.name}</td>
                            <td className="">{item?.vendor?.name}</td>
                            <td className="">
                              {item?.quantity}{" "}
                              {item?.quantity - item?.quantityUsed <=
                              item?.minimumQuantityLevel ? (
                                <Chip
                                  size="small"
                                  color="warning"
                                  label="Low stock"
                                />
                              ) : (
                                ""
                              )}{" "}
                            </td>
                            <td className="">
                              {item?.quantity - item?.quantityUsed}
                            </td>
                            {/* <td className="">{item?.price}</td> */}
                            {/* <td className="">{item?.purchasePrice}</td> */}
                            <td className="">{item?.minimumQuantityLevel}</td>
                            <td className="">{item?.quantityUsed}</td>
                            <td>
                              <div className="dropdown p-0 align-items-center justify-content-center">
                                <i
                                  className="fas fa-ellipsis-v pointer p-2"
                                  id="dropdownMenuLink"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                />
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuLink"
                                >
                                  <li
                                    onClick={() =>
                                      handleOpenPurchaseModal(item)
                                    }
                                    style={{ cursor: "pointer" }}
                                    className="dropdown-item"
                                  >
                                    Create Purchase Order
                                  </li>
                                  <li
                                    className="dropdown-item"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleOpenAssignModal(item._id, "ASSIGN")
                                    }
                                  >
                                    Assign
                                  </li>

                                  <li
                                    className="dropdown-item"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleOpenAssignModal(item._id, "In-Use")
                                    }
                                  >
                                    In-Use
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                      <td colSpan={"20"}>
                        {inventoryList?.totalCount > 10 && (
                          <Pagination
                            style={{ backgroundColor: "#fff" }}
                            className=""
                            count={totalCount}
                            controller={controller}
                            setController={handlePagination}
                          />
                        )}
                      </td>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size="md"
        show={stockModal.open}
        onHide={() => setStockModal((prev) => ({ ...prev, open: false }))}
        headerContent={
          <h5 className="py-2">
            {stockModal?.data?.actionType === "add"
              ? "Add Stock"
              : "Update Stock"}
          </h5>
        }
        bodyContent={
          <div className="">
            {/* Input Field */}
            <div className="mb-3">
              <TextInput
                Lable="Stock Quantity"
                Name="quantity"
                variant="outlined"
                type={"number"}
                ClassName="form-field-design"
                Require={true}
                HandleInputChange={handleInputStockChange}
                // onBlur={handleBlur}
                Value={stockData?.quantity}
                width={100}
                Error={error.quantity}
              />
            </div>

            {/* Submit Button */}
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="contained"
                onClick={async () => {
                  const success = await AddUpdateStock(
                    stockModal?.data?.actionType
                  );
                  if (success) {
                    setStockModal((prev) => ({ ...prev, open: false }));
                  }
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        }
      />

      {/* Create purchase modal */}

      <Modal
        size="md"
        show={purchaseModal}
        onHide={handleClosePurchaseModal}
        headerContent={<h5>Create Purchase Order</h5>}
        bodyContent={
          <div className="row">
            <div className=" pt-2">
              <TextFields
                Lable="Purchase Date"
                Name="purchaseDate"
                type="date"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeCreatePirce}
                Value={formDataCreatePurchase.purchaseDate}
                width={100}
              />
            </div>
            <div className="pt-2">
              <TextFields
                Lable="Quantity"
                Name="quantity"
                type="number"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeCreatePirce}
                Value={formDataCreatePurchase.quantity}
                width={100}
              />
            </div>
            <div className="pt-2">
              <TextFields
                Lable="MRP"
                Name="price"
                type="number"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeCreatePirce}
                Value={formDataCreatePurchase.price}
                width={100}
              />
            </div>
            <div className="pt-2">
              <TextFields
                Lable="Purchase Price"
                Name="purchasePrice"
                variant="outlined"
                type="number"
                ClassName="form-field-design"
                HandleInputChange={handleChangeCreatePirce}
                Value={formDataCreatePurchase.purchasePrice}
                width={100}
              />
            </div>
            {/* <div className="pt-2">
              <InputLabel id="vendor-select-label">Vendor</InputLabel>
              <Select
                labelId="vendor-select-label"
                id="vendor-select"
                name="vendor"
                onChange={handleChangeCreatePirce}
                error={formErrorCreatePurchase.vendor}
                value={formDataCreatePurchase.vendor}
                required={true}
                style={{ height: "35px", width: "100%" }}
                MenuProps={{
                  PaperProps: { style: { maxHeight: 200 } },
                  MenuListProps: { sx: { py: 0 } },
                }}
              >
                <MenuItem
                  onClick={handleOpenVendorModal}
                  value=""
                  style={{ fontWeight: "700" }}
                >
                  Add vendor
                  <AddCircleIcon
                    color="primary"
                    fontSize="30x"
                    style={{ marginInline: "5px" }}
                  />
                </MenuItem>

                {vendorList.map((item) => (
                  <MenuItem value={item?._id} key={item?._id}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
              {formErrorCreatePurchase.vendor && (
                <small className="text-danger">
                  {formErrorCreatePurchase.vendor}
                </small>
              )}
            </div> */}
            <div className="pt-2">
              <div className="d-flex justify-content-between align-items-center">
                <InputLabel id="vendor-select-label" sx={{ fontSize: "13px" }}>
                  Vendor <span className="text-danger">*</span>
                </InputLabel>

                <div
                  className="d-flex gap-1 cursor-pointer"
                  onClick={handleOpenVendorModal}
                >
                  <span className="fw-ligher">Add Vendor</span>
                  <AddCircleIcon
                    color="primary"
                    fontSize="medium"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              <MultipleSelect
                options={vendorList.map((item) => ({
                  id: item._id,
                  name: item.name,
                }))}
                searchBy="name"
                keyName="name"
                name="vendor"
                value="id"
                error={formErrorCreatePurchase?.vendor}
                selectedValues={
                  formDataCreatePurchase.vendor
                    ? [
                        {
                          id: formDataCreatePurchase.vendor,
                          name:
                            vendorList.find(
                              (x) => x._id === formDataCreatePurchase.vendor
                            )?.name || "",
                        },
                      ]
                    : []
                }
                onChange={(selected) => {
                  const newValue = selected.length > 0 ? selected[0].id : "";
                  setFormDataCreatePurchase((prev) => ({
                    ...prev,
                    vendor: newValue,
                  }));

                  if (newValue) {
                    setFormErrorCreatePurchase((prev) => ({
                      ...prev,
                      vendor: "",
                    }));
                  }
                }}
              />
            </div>
            <div className="pt-2">
              <TextFields
                Lable="Remarks"
                Name="remarks"
                variant="outlined"
                type="text"
                ClassName="form-field-design"
                HandleInputChange={handleChangeCreatePirce}
                Value={formDataCreatePurchase.remarks}
                width={100}
              />
            </div>
            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={handleClosePurchaseModal}>
                cancel
              </Button>
              <Button
                onClick={addPurchaseStock}
                variant="contained"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Add
              </Button>
            </div>
          </div>
        }
      />

      {/* ADD VENDOR */}
      <Modal
        size="md"
        show={vendorModal}
        onHide={handleCloseVendorModal}
        headerContent={<h5>Add vendor</h5>}
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Vendor"
                  Name="name"
                  Require={true}
                  Error={errorVendor.name}
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.name}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="GST Number"
                  Name="gstNumber"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.gstNumber}
                  width={100}
                />
              </div>
              <div className="pt-2">
                <TextFields
                  Lable="Address"
                  Name="address"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChangeVendor}
                  Value={formDataVendor.address}
                  width={100}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="contained" onClick={handleCloseVendorModal}>
                cancel
              </Button>
              <Button
                onClick={addVendor}
                variant="outlined"
                className="ms-2"
                data-bs-dismiss="modal"
              >
                Add
              </Button>
            </div>
          </div>
        }
      />

      {/* Assign Stock */}

      <Modal
        size="md"
        show={assignModal}
        onHide={handleCloseAssignModal}
        headerContent={
          <h5> {assignType === "ASSIGN" ? "Assign Stock" : "Use Stock"} </h5>
        }
        bodyContent={
          <div className="row">
            <div className="pt-2">
              <TextFields
                Lable={
                  assignType === "ASSIGN" ? "Date Of Assign" : "Date Of Use"
                }
                Name="dateOfAssign"
                type="date"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeAssignStock}
                Value={formDataAssignStock.dateOfAssign}
                width={100}
              />
            </div>

            <div className="pt-2">
              <TextFields
                Lable={
                  assignType === "ASSIGN"
                    ? "Assign Quantity"
                    : "Assign Use Quantity"
                }
                Name="assignQuantity"
                type="number"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeAssignStock}
                Value={formDataAssignStock.assignQuantity}
                width={100}
              />
            </div>
            {assignType === "ASSIGN" && (
              <div className="pt-2">
                {/* <InputLabel id="vendor-select-label">Type Of Assign</InputLabel>
                <Select
                  labelId="vendor-select-label"
                  id="vendor-select"
                  name="typeOfAssign"
                  onChange={handleChangeAssignStock}
                  value={formDataAssignStock.typeOfAssign}
                  error={formErrorAssignStock.typeOfAssign}
                  required={true}
                  style={{ height: "35px", width: "100%" }}
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 200 } },
                    MenuListProps: { sx: { py: 0 } },
                  }}
                  placeholder="Select type of assign"
                >
                  {typeOfAssignList.map((item) => (
                    <MenuItem value={item?.id} key={item?.id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
                {formErrorAssignStock.typeOfAssign && (
                  <small className="text-danger">
                    {formErrorAssignStock.typeOfAssign}
                  </small>
                )} */}
                <MultipleSelect
                  label="Type Of Assign"
                  options={typeOfAssignList.map((item) => ({
                    id: item.id,
                    name: item.name,
                  }))}
                  searchBy="name"
                  keyName="name"
                  name="typeOfAssign"
                  value="id"
                  error={formErrorAssignStock?.typeOfAssign}
                  selectedValues={
                    formDataAssignStock.typeOfAssign
                      ? [
                          {
                            id: formDataAssignStock.typeOfAssign,
                            name:
                              typeOfAssignList.find(
                                (x) =>
                                  x._id === formDataAssignStock.typeOfAssign
                              )?.name || "",
                          },
                        ]
                      : []
                  }
                  onChange={(selected) => {
                    const newValue = selected.length > 0 ? selected[0].id : "";
                    setFormDataAssignStock((prev) => ({
                      ...prev,
                      typeOfAssign: newValue,
                    }));

                    if (newValue) {
                      setFormErrorAssignStock((prev) => ({
                        ...prev,
                        typeOfAssign: "",
                      }));
                    }
                  }}
                />
              </div>
            )}

            {assignType === "ASSIGN" && (
              <div className="pt-2">
                {/* <InputLabel id="vendor-select-label">Employee</InputLabel>
                <Select
                  labelId="vendor-select-label"
                  id="vendor-select"
                  name="employee_id"
                  onChange={handleChangeAssignStock}
                  value={formDataAssignStock.employee_id}
                  required
                  style={{ height: "35px", width: "100%" }}
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 200 } },
                    MenuListProps: { sx: { py: 0 } },
                  }}
                  placeholder="Select type of assign"
                >
                  {employeeList.map((item) => (
                    <MenuItem value={item?._id} key={item?._id}>
                      {item?.firstName} {item?.lastName}
                    </MenuItem>
                  ))}
                </Select> */}
                <MultipleSelect
                  label="Employee"
                  options={employeeList.map((item) => ({
                    id: item._id,
                    name: `${item.firstName || ""} ${
                      item.lastName || ""
                    }`.trim(),
                  }))}
                  searchBy="name"
                  keyName="name"
                  name="employee_id"
                  value="id"
                  error={formErrorAssignStock?.employee_id}
                  selectedValues={
                    formDataAssignStock.employee_id
                      ? [
                          {
                            id: formDataAssignStock.employee_id,
                            name:
                              employeeList.find(
                                (x) => x._id === formDataAssignStock.employee_id
                              )?.name || "",
                          },
                        ]
                      : []
                  }
                  onChange={(selected) => {
                    const newValue = selected.length > 0 ? selected[0].id : "";
                    setFormDataAssignStock((prev) => ({
                      ...prev,
                      employee_id: newValue,
                    }));

                    if (newValue) {
                      setFormErrorAssignStock((prev) => ({
                        ...prev,
                        employee_id: "",
                      }));
                    }
                  }}
                />
              </div>
            )}
            <div className="pt-2">
              <TextFields
                Lable="Remarks"
                Name="remarks"
                type="text"
                variant="outlined"
                ClassName="form-field-design"
                HandleInputChange={handleChangeAssignStock}
                Value={formDataAssignStock.remarks}
                width={100}
              />
            </div>
            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={handleCloseAssignModal}>
                cancel
              </Button>
              {assignType === "ASSIGN" ? (
                <Button
                  onClick={addAssignStock}
                  variant="contained"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Add
                </Button>
              ) : (
                <Button
                  onClick={addUseStock}
                  variant="contained"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Add
                </Button>
              )}
            </div>
          </div>
        }
      />
    </>
  );
};

export default Inventory;
